<template>
  <InitForm/>
</template>

<script lang="ts">
import {defineComponent, ref} from "vue";
import InitForm from "@/components/Login/InitForm.vue";

export default defineComponent({
  name: "Login",
  components: {
    InitForm
  },
  setup() {
    return {
    }
  }
});
</script>
